import data_science_image from "../assets/images/dATA-SCI-web.jpg";
import data_analysis_image from "../assets/images/dATA-SCI-Recovered-web.jpg";
import ui_ux_image from "../assets/images/UI UX-web.jpg";
import web_dev_image from "../assets/images/WEB-Recovered-web.jpg";

const DATA = [
  {
    id: 1,
    courseName:"Online UI/UX Training",
    courseDescription:
      "Enroll for our Intensive online UI/UX Training, Learning pace is for 2hrs, three times weekly. Master the art of designing user-friendly and visually appealing digital experiences using Figma.",
    coursePrice: "50,000",
    courseTime: "8 weeks",
    courseImage: ui_ux_image,
    slot: "online-ui-ux-training",
  },
  {
    id: 2,
    courseName: "Online Web Development Training",
    courseDescription:
      "Learn to build dynamic and interactive websites using HTML, CSS, and JavaScript and react frame work for front-end, and Laravel a robost PHP framework for backend, with projects.Learning pace is for 2hrs, three times weekly.",
    coursePrice: "50,000",
    courseTime: "8 weeks",
    courseImage: web_dev_image,
    slot: "online-web-development-training",
  },
  {
    id: 3,
    courseName: "Online Data Science Training",
    courseDescription:
      "Explore the world of data with this comprehensive program covering machine learning, statistics, and data visualization.project based. Learning pace is for 2hrs, three times weekly.",
    coursePrice: "50,000",
    courseTime: "8 weeks",
    courseImage: data_science_image,
    slot: "online-data-science-training",
  },
  {
    id: 4,
    courseName: "Online Data Analysis Training",
    courseDescription:
      "Gain valuable skills in data cleaning, transformation, and analysis to extract meaningful insights.tech stack includes: Excel, Power BI and Python.Learning pace is for 2hrs, three times weekly.",
    coursePrice: "50,000",
    courseTime: "8 weeks",
    courseImage: data_analysis_image,
    slot: "online-data-analysis-training",
  },
];

export default DATA;
